import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      className="bg-[#0a0a0a]"
      style={{ padding: '80px 0 40px' }}
    >
      <div className="container-professional">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          
          {/* Company */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <span 
                className="font-semibold text-lg"
                style={{ 
                  fontFamily: 'Inter, system-ui, sans-serif',
                  color: '#FFFFFF',
                  letterSpacing: '-0.02em'
                }}
              >
                AffinityAim
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-6 max-w-sm" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              We build apps and websites that actually help your business grow. Founded 2023.
            </p>
            <div className="text-sm">
              <a 
                href="mailto:post@affinityaim.com" 
                className="transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                post@affinityaim.com
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">
              Services
            </h3>
            <div className="space-y-2.5 text-sm">
              <Link 
                to="/services/website-development" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                Website Development
              </Link>
              <Link 
                to="/services/web-app-development" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                Web Apps
              </Link>
              <Link 
                to="/services/ui-ux-design" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                UI/UX Design
              </Link>
              <Link 
                to="/services/ai-integration" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                AI Integration
              </Link>
              <Link 
                to="/pricing" 
                className="block transition-colors hover:text-white font-medium"
                style={{ color: '#00e5ff' }}
              >
                Website plans ($500–$1,000/year)
              </Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">
              Company
            </h3>
            <div className="space-y-2.5 text-sm">
              <Link 
                to="/about" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                About
              </Link>
              <Link 
                to="/enterprise" 
                className="block transition-colors hover:text-white font-medium"
                style={{ color: '#00e5ff' }}
              >
                Enterprise
              </Link>
              <Link 
                to="/portfolio" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                Portfolio
              </Link>
              <Link 
                to="/pricing" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                Pricing
              </Link>
              <Link 
                to="/contact" 
                className="block transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.6)' }}
              >
                Contact
              </Link>
            </div>
          </div>

        </div>

        {/* Bottom section */}
        <div className="pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs" style={{ color: 'rgba(255, 255, 255, 0.4)' }}>
            <div className="flex items-center gap-3">
              <p>© {currentYear} AffinityAim. All rights reserved.</p>
            </div>
            <div className="flex gap-6">
              <Link 
                to="/privacy" 
                className="transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.4)' }}
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="transition-colors hover:text-white"
                style={{ color: 'rgba(255, 255, 255, 0.4)' }}
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};